import { useEffect } from "react";
import React, { useState } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import Page from "../../../components/Page";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./SuggestedCoaches.scss";
import { useNavigate } from "react-router-dom";
import _, { forEach } from "lodash";
import {
  coachingRequestSubmitClear,
  getAllSkills,
  getSlots,
  getSlotsClear,
} from "../../../redux/coaching/actions";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import moment from "moment";

import {
  convertTimeInHourAndMin,
  getProcureInfo,
  ProductCardPriceInfo,
  SessionKeys,
} from "../../../utils/AppUtils";
import CartPopUpComponent from "../../../components/NewDesign/DetailPage/CartPopUp/CartPopUpComponent";
import NotFoundComponent from "../../../components/NewDesign/NotFound/NotFoundComponent";
import { addCoachingNotesListReq, getCityList } from "../../../redux/user/actions";
import Loader from "../../../components/Loader/Loader";
import ShimmerScreen from "../../../components/Layouts/ShimmerScreen";
import ConfirmModal from "../../../components/modal/ConfirmModal";
import { useTranslation } from "react-i18next";

function SuggestedCoaches({ coachesData, isLoading }) {


  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);

  const coachingRequestData = location.state?.coachesData;
  const service_code = coachingRequestData?.payload?.payload.List[0]?.service_code
  // payload.payload.List[0].service_code
  // useEffect(()=>{console.log("service_code",service_code)},[])
  if (!_.isEmpty(coachesData)) {
    coachingRequestData = coachesData;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoader(isLoading);
  }, [isLoading]);

  const c = params.get("c");
  let provider_id = "";
  let provider_name = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    provider_id = paramsReq.provider_id;
    provider_name = paramsReq.provider_name;
  }

  const coachingStore = useSelector((state) => state.coaching.skillsList);
  const citiesList = useSelector((state) => state.user.getCitiesList);

  const [selectedCoachId, setSelectedCoachId] = useState(null);
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [slotsData, setSlotsData] = useState([]);
  const [error, setError] = useState("");
  const [priceInfo, setPriceInfo] = useState();
  const [key, setKey] = useState("YourCoaches");
  const navigate = useNavigate();
  const [headerProdData, setHeaderProdData] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sessionModel, setSessionModel] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0);
  const [dateRange, setDateRange] = useState({
    start_date: moment()
      .startOf("week")
      .clone()
      .add(-1, "d")
      .format("MM/DD/YYYY"),
    end_date: moment()
      .startOf("week")
      ?.clone()
      .endOf("week")
      .clone()
      .add(1, "d")
      .format("MM/DD/YYYY"),
  });
  const [activeTab, setActiveTab] = useState("thisWeek");
  const [currentWeek, setCurrentWeek] = useState([]);
  const [nextWeek, setNextWeek] = useState([]);
  const [currentMonthWeeks, setCurrentMonthWeeks] = useState([]);
  const [nextMonthWeeks, setNextMonthWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState([]);
  const [sessions, setSessions] = useState({});
  const [filteredSessions, setFilteredSessions] = useState([]);
  const [activeMonthWeeks, setActiveMonthWeeks] = useState([]);
  const [selectedWeekDays, setSelectedWeekDays] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [activeSlot, setActiveSlot] = useState(null);
  const [thisWeekSlots, setThisWeekSlots] = useState([]);
  const [nextWeekSlots, setNextWeekSlots] = useState([]);
  const [currentMonthSlots, setCurrentMonthSlots] = useState([]);
  const [nextMonthSlots, setNextMonthSlots] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [apiCalled, setApiCalled] = useState(false);
  const [skillsList, setSkillsList] = useState([]);
  const [skillsSet, setSkillsSet] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [industry, setIndustry] = useState([]);
  const [selectedExperience, setSelectedExperience] = useState("");
  const [citiesData, setCitiesData] = useState([]);
  const [languagesList, setLanguagesList] = useState([
    { id: 1, name: "English" },
    { id: 2, name: "French" },
  ]);

  useEffect(() => {
    getAllSkillsAPI()
    getCitiesAPI()
  }, [dispatch])


  useEffect(() => {
    console.log("coachingStore", coachingStore);
    if (!_.isEmpty(coachingStore)) {
      if (coachingStore?.status === "success") {
        setIndustry(coachingStore?.payload?.payload?.industry);

        let list = coachingStore?.payload?.payload?.skill;
        setSkillsSet(list);
        setSkillsList(
          _.map(list, (skill) => {
            return {
              value: skill?.id,
              label: skill?.name,
            };
          })
        );
      } else {
        setSkillsList([]);
      }
    }
  }, [coachingStore]);

  useEffect(() => {
    console.log("cities-", citiesList);
    if (!_.isEmpty(citiesList)) {
      if (citiesList?.status === "success") {
        setCitiesData(citiesList?.payload?.payload?.city);
      } else {
        setCitiesData([]);
      }
    }
  }, [citiesList]);

  useEffect(() => {
    // Assuming the function filterCurrentMonth is already filtering and grouping slots
    const weeksInMonth = filterCurrentMonth(slotsData);
    setActiveMonthWeeks(weeksInMonth); // Set the grouped weeks
  }, [slotsData]);

  useEffect(() => {
    setActiveSlot(null);
    if (activeTab === "thisWeek") {

      filterThisWeek();
    } else if (activeTab === "nextWeek") {
      filterNextWeek();
    } else if (activeTab === "currentMonth") {
      filterCurrentMonth();
    } else if (activeTab === "nextMonth") {
      filterNextMonth();
    }
  }, [activeTab]);

  const getAllSkillsAPI = () => {
    dispatch(
      getAllSkills({
        module: "getAllSkills",
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      })
    );
  };

  const getCitiesAPI = () => {
    dispatch(
      getCityList({
        module: "getCities",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  const requestSessions = (user_id) => {
    setActiveTab("thisWeek");
    setSelectedCoachId(user_id);
    setSessionModel(true);
  };
  const handleError = () => {
    // Set the error message
    setError(t("pleaseSelectValidSessionBeforeBooking"));

    // Clear the error message after 5 seconds
    setTimeout(() => {
      setError("");
    }, 5000);
  };
  

  const generateWeeks = (monthOffset) => {
    const startOfMonth = moment().add(monthOffset, "month").startOf("month");
    const endOfMonth = moment().add(monthOffset, "month").endOf("month");

    const weeks = [];
    let currentWeekStart = startOfMonth.clone().startOf("week");

    while (currentWeekStart.isBefore(endOfMonth)) {
      const weekEnd = currentWeekStart.clone().endOf("week");
      weeks.push({
        start: currentWeekStart.format("YYYY-MM-DD"), // Full date format
        end: weekEnd.format("YYYY-MM-DD"), // Full date format
      });
      currentWeekStart.add(1, "week");
    }

    return weeks;
  };

  const handleTopTabClick = (tab) => {
    setActiveTab(tab);
    setSelectedWeek(null); // Reset selected week on tab change
    setSelectedWeekDays([]); // Clear selected week days

    if (tab === "currentMonth") {
      setActiveMonthWeeks(generateWeeks(0)); // Generate weeks for the current month
    } else if (tab === "nextMonth") {
      setActiveMonthWeeks(generateWeeks(1)); // Generate weeks for the next month
    }
  };


  const filterThisWeek = (slots) => {
    if (!Array.isArray(slots)) {
      console.error("Invalid slots data:", slots);
      return [];
    }

    const startOfWeek = moment().startOf("week"); // Start of the current week
    const endOfWeek = moment().endOf("week"); // End of the current week

    const filteredSlots = [];

    slots.forEach((session) => {
      if (session.slot && Array.isArray(session.slot)) {
        const slotDate = moment(session.date);
        if (slotDate.isBetween(startOfWeek, endOfWeek, "day", "[]" )) {
          filteredSlots.push(session);
        }
        // session.slot.forEach((slot) => {
          
        
        // });
      } else {
        console.warn("Session slot is missing or not an array:", session);
      }
    });
    console.log("filteredSlots", filteredSlots);
    return filteredSlots;
  };

  const filterNextWeek = (slots) => {
    if (!Array.isArray(slots)) {
      console.error("Invalid slots data:", slots);
      return [];
    }

    const startOfNextWeek = moment().add(1, "week").startOf("week"); // Start of the next week
    const endOfNextWeek = moment().add(1, "week").endOf("week"); // End of the next week

    const filteredSlots = [];

    slots.forEach((session) => {
      if (session.slot && Array.isArray(session.slot)) {
        const slotDate = moment(session.date);
        if (slotDate.isBetween(startOfNextWeek, endOfNextWeek, "day", "[]")) {
          filteredSlots.push(session);
        }
        // session.slot.forEach((slot) => {
         
          
        // });
      } else {
        console.warn("Session slot is missing or not an array:", session);
      }
    });
    console.log("nextweek", filteredSlots);
    return filteredSlots;
  };

  const filterCurrentMonth = (slots) => {
    if (!Array.isArray(slots)) {
      console.error("Invalid slots data:", slots);
      return [];
    }

    const startOfMonth = moment().startOf("month"); // Start of the current month
    const endOfMonth = moment().endOf("month"); // End of the current month

    const filteredSlots = [];

    // Step 1: Filter slots belonging to the current month
    slots.forEach((session) => {
      if (session.slot && Array.isArray(session.slot)) {
        session.slot.forEach((slot) => {
          const slotDate = moment(slot.date);
          if (slotDate.isBetween(startOfMonth, endOfMonth, "day", "[]")) {
            filteredSlots.push(slot);
          }
        });
      } else {
        console.warn("Session slot is missing or not an array:", session);
      }
    });

    // Step 2: Group slots by week number
    const groupedByWeek = filteredSlots.reduce((groups, slot) => {
      const weekNumber = moment(slot.date).week(); // Get the week number of the year
      if (!groups[weekNumber]) {
        groups[weekNumber] = [];
      }
      groups[weekNumber].push(slot);
      return groups;
    }, {});

    console.log("Current month grouped by week:", groupedByWeek);
    return groupedByWeek;
  };

  const filterNextMonth = (slots) => {
    if (!Array.isArray(slots)) {
      console.error("Invalid slots data:", slots);
      return [];
    }

    const startOfNextMonth = moment().add(1, "month").startOf("month"); // Start of the next month
    const endOfNextMonth = moment().add(1, "month").endOf("month"); // End of the next month

    const filteredSlots = [];

    slots.forEach((session) => {
      if (session.slot && Array.isArray(session.slot)) {
        session.slot.forEach((slot) => {
          const slotDate = moment(slot.date);
          if (
            slotDate.isBetween(startOfNextMonth, endOfNextMonth, "day", "[]")
          ) {
            filteredSlots.push(slot);
          }
        });
      } else {
        console.warn("Session slot is missing or not an array:", session);
      }
    });
    console.log("nextmonth", filteredSlots);
    return filteredSlots;
  };

  const handleWeekSelection = (weekIndex) => {
    setSelectedWeek(weekIndex); // Set selected week
    const selectedWeekData = activeMonthWeeks[weekIndex];

    // Get the days of the selected week
    // const weekDays = selectedWeekData.map((slot) => moment(slot.date).format("dddd, DD MMM"));
    // setSelectedWeekDays(weekDays); // Set the days of the selected week
  };

  useEffect(() => {
    handleTopTabClick("thisWeek");
  }, []);

  // useEffect(() => {
  //   // Generate current and next week
  //   const today = moment();
  //   const startOfCurrentWeek = today.clone().startOf("isoWeek");
  //   const startOfNextWeek = startOfCurrentWeek.clone().add(1, "week");

  //   setCurrentWeek(
  //     Array.from({ length: 5 }, (_, i) =>
  //       startOfCurrentWeek.clone().add(i, "days").format("ddd, DD MMM")
  //     )
  //   );
  //   setNextWeek(
  //     Array.from({ length: 5 }, (_, i) =>
  //       startOfNextWeek.clone().add(i, "days").format("ddd, DD MMM")
  //     )
  //   );

  //   // Generate weeks for current and next month
  //   setCurrentMonthWeeks(generateWeeks(0));
  //   setNextMonthWeeks(generateWeeks(1));
  // }, []);

  // console.log("Received Data:", coachingRequestData?.payload?.payload?.List);

  const navigateToView = (data) => {
    let paramsReq = {
      service_code: data?.service_code,
      provider_name: provider_name,
      provider_id: provider_id,
      service_id: data?.product_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/coaching-detail?c=${encodedUrl}`;
    navigate(url);
  };
  const userDetailRes = useSelector((state) => state.user.userBroker);
  console.log("userDetailRes", userDetailRes);
  function BookSession({ date, startTime, endTime,id }) {
    setApiCalled(true);
    let req = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      user_id: localStorage.getItem(SessionKeys.USER_ID),
      coach_uid: selectedCoachId,
      title: "Testing",
      start_date: date,
      followup_title: "Follow-up title",
      follow_up: date,
      follow_start_time: startTime,
      follow_end_time: endTime,
      notes: "sssss",
      slot_id:id
    };

    setSessionModel(false);
    setLoader(true);
    setSelectedSession(null);
    setActiveSlot(null);

    dispatch(
      addCoachingNotesListReq({
        module: "addCoachingNotesData",
        postData: req,
      })
    );
  }

  const addCoachingNotesListRes = useSelector(
    (state) => state.user.addCoachingNotesList
  );
  useEffect(() => {
    console.log("addCoachingNotesListtRes: ", addCoachingNotesListRes);
    if (!_.isEmpty(addCoachingNotesListRes) && apiCalled) {
      if (addCoachingNotesListRes?.status === "success") {
        setLoader(false);
        setShowModalMsg("Session booked successfully");
        setConfirmModal(true);

        let response = addCoachingNotesListRes?.payload?.payload;
        // console.log("asdasdasdasdsadsadasd", addCoachingNotesListRes?.status)
      }
      setApiCalled(false);
    }
  }, [addCoachingNotesListRes]);
  const formatDataForCoaches = (list) => {
    console.log("list--", list);
    let eventArr = [];
    for (let item of list) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      logoURL = item?.provider?.provider_img;
      tags.push(item?.provider?.provider_display_name);
      tags.push(item?.service_type);
      tags.push(
        _.toLower(item?.payment_frequency) === "monthly"
          ? "Subscription"
          : "One Time"
      );
      let priceInfo = getProcureInfo(item.purchased_info);
      eventArr.push({
        id: item?.product_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        is_wishlist: item?.is_addtowishlist,
        dbId: item?.list_id,
        is_coaching: true,
        show_subscription:
          _.toLower(item?.payment_frequency) === "monthly" ? true : false,
        productType: item?.service_type,
        productOrigin: item?.source,
        title: item.product_name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.product_thumbnail,
        tagsArray: tags,
        description: item.summary ? item.summary : "",
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showPlayButton: false,
        showProviderIcon: true,
        showLikeMenu: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        btnAction: () => proceedToPurchase(item, priceInfo),
        descAction: () => { },
        bannerAction: () => { },
        cardClassName: "",
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        priceInfo,
        partner: item?.partner,
        data: item,
      });
    }
    return eventArr;
  };

  useEffect(() => {
    if (!_.isEmpty(coachingRequestData?.payload?.payload?.List)) {
      let list = formatDataForCoaches(
        coachingRequestData?.payload?.payload?.List
      );
      setData(list);
      setPriceInfo(
        getProcureInfo(
          coachingRequestData?.payload?.payload?.List[0].purchased_info
        )
      );
    }
  }, [coachingRequestData]);

  const proceedToPurchase = (coachingDetailData, priceInfo1) => {
    let tags = [];
    let logoURL = "";
    if (!_.isEmpty(coachingDetailData.provider)) {
      logoURL = coachingDetailData.provider.provider_img;
    }

    let priceInfo = _.cloneDeep(priceInfo1);
    priceInfo.isAddToCart = coachingDetailData.is_addtocart;
    setIsOpen(true);
    setHeaderProdData({
      id: coachingDetailData?.product_id,
      title: coachingDetailData?.partner?.display_name,
      logoURL: logoURL,
      logoAltText: "ED",
      bannerURL: coachingDetailData?.partner?.thumbnail,
      tagsArray: coachingDetailData?.partner?.skill,
      description: coachingDetailData?.short_description,
      duration: "",
      view: "",
      price: priceInfo.price,
      isPaid: priceInfo.isPurchased,
      priceInfo: priceInfo,
      productType: "subscription-product",
      priceType: coachingDetailData.payment_frequency,
    });
  };

  const handleSearchClick = () => {
    let searchedData = data?.filter((item) =>
      _.toLower(item?.partner?.display_name)?.includes(_.toLower(searchText))
    );
    console.log("searched", searchedData);
    setData(searchedData);
  };

  const [slotsApiCalled, setSlotsApiCalled] = useState(false);

  const getSessionData = (id) => {
    setSlotsApiCalled(true);
    setIsFetching(true);
    dispatch(
      getSlots({
        module: "getSlotsModule",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          coach_id: id,
          // date_range: dateRange,
        },
      })
    );
  };

  useEffect(() => {
    console.log("coach id", selectedCoachId);
    getSessionData(selectedCoachId);
  }, [dateRange, selectedCoachId]);

  const getSessionsAccordingTab = (coachId) => {
    console.log(
      "Sessions are being fetched according to the tab for coachId:",
      coachId
    );
    // Your logic to handle fetching sessions based on the tab and coachId
  };
  const sessionDetails = useSelector((state) => state.coaching.getSlotsData);
  useEffect(() => {
    console.log("sessionDetails", sessionDetails);
    console.log("slotsApiCalled", slotsApiCalled );
    if (!_.isEmpty(sessionDetails) && slotsApiCalled) {
      if (sessionDetails?.status === "success") {
        const slots = sessionDetails?.payload?.payload;
        // Extract slot data
        console.log("slots1", slots );
      
        setSlotsData(slots);
        setIsFetching(false);

        if (Array.isArray(slots)) {
          setSlotsData(slots);
          const filteredThisWeek = filterThisWeek(slots);
          console.log("filteredThisWeek",filteredThisWeek,"slots",slots)
          setThisWeekSlots(filteredThisWeek);
          const filteredNextWeek = filterNextWeek(slots);
          setNextWeekSlots(filteredNextWeek);
          const filteredCurrentMonth = filterCurrentMonth(slots);
          setCurrentMonthSlots(filteredCurrentMonth);
          const filteredNextMonth = filterNextMonth(slots);
          setNextMonthSlots(filteredNextMonth);
        } else {
          console.error("Slots data is not an array:", slots);
          setSlotsData([]);
          setThisWeekSlots([]);
          setNextWeekSlots([]);
          setCurrentMonthSlots([]);
          setNextMonthSlots([]);
        }
        // const formattedSlots = slots.reduce((acc, item) => {
        //   acc[item.date] = item.slot.map((slot) => ({
        //     id: slot.id,
        //     startTime: moment.unix(slot.start_time).format("hh:mm A"),
        //     endTime: moment.unix(slot.end_time).format("hh:mm A"),
        //   }));
        //   return acc;
        // }, {});
        // console.log(
        //   "Formatted Slots:",
        //   JSON.stringify(formattedSlots, null, 2)
        // ); // Debug log
        // setSessions(formattedSlots); // Store the formatted data
      } else {
        console.error("Failed to fetch slots.");
        setSlotsData([]);
        setIsFetching(false);
      }
      setSlotsApiCalled(false);
    }
  }, [sessionDetails]);
  function onCancel() {
    setSessionModel(false);
    setSelectedSession(null);
    setActiveSlot(null);

  }

  const getFilteredSlotsLength = (
    slotsData,
    activeMonthWeeks,
    selectedWeek
  ) => {
    if (!slotsData || !Array.isArray(slotsData)) {
      return 0; // Return 0 if any of the required data is invalid or undefined
    }

    const weekStart = moment(
      activeMonthWeeks[selectedWeek]?.start,
      "YYYY-MM-DD"
    );
    const weekEnd = moment(activeMonthWeeks[selectedWeek]?.end, "YYYY-MM-DD");

    return slotsData.filter((dayData) => {
      const dayDataDate = moment(dayData.date, "YYYY-MM-DD");
      return dayDataDate.isBetween(weekStart, weekEnd, "days", "[]");
    }).length;
  };

  const filteredSlotsLength = getFilteredSlotsLength(
    slotsData,
    activeMonthWeeks,
    selectedWeek
  );
  return (
    <Page>
      <>
        <Loader start={loader} />
        <section className="suggested-coaching">
          <div className="container mt-4">
            <button className="mb-4 bck-btn" onClick={() => navigate(-1)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="17"
                viewBox="0 0 10 17"
                fill="none"
              >
                <path
                  d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                  fill="black"
                />
              </svg>{" "}
              {t("back")}
            </button>
            {/* <div className="row">
              <div className="col-md-12">
                <div className="d-flex voachingbox">
                  <div className="lefxobox">
                    <svg
                      width="44"
                      height="44"
                      viewBox="0 0 44 44"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="22"
                        cy="22"
                        r="22"
                        fill="url(#paint0_linear_887_23357)"
                      />
                      <g clip-path="url(#clip0_887_23357)">
                        <path
                          d="M22.3621 12.1875C20.2008 12.5776 19.0405 15.006 20.0673 16.9877C20.4626 17.7475 21.3405 18.4406 22.1619 18.6356C22.6599 18.7537 23.5737 18.7127 24.0255 18.5535C25.576 18.0042 26.5001 16.2535 26.0894 14.6415C25.9199 13.9792 25.6992 13.5993 25.2115 13.1116C24.7545 12.6547 24.4106 12.4442 23.8253 12.2696C23.4865 12.1669 22.7215 12.1207 22.3621 12.1875ZM23.4146 13.9125C23.7996 14.0254 24.2822 14.508 24.4054 14.9033C24.6005 15.5194 24.4568 16.1303 24.0101 16.5821C23.24 17.347 21.9925 17.1057 21.5253 16.0944C21.3302 15.6734 21.3354 15.1497 21.5407 14.7339C21.9001 14.0203 22.6548 13.6866 23.4146 13.9125Z"
                          fill="white"
                        />
                        <path
                          d="M14.9489 14.6826C14.302 14.8571 13.6705 15.3602 13.383 15.925C13.0955 16.4948 13.0955 16.4383 13.0955 21.4131V25.9977H12.6078C12.0226 25.9977 11.7864 26.0901 11.6016 26.393C11.4989 26.5573 11.4784 26.6702 11.463 27.1323C11.4219 28.2104 11.6478 28.9137 12.2074 29.4425C12.3717 29.5965 12.6078 29.7865 12.7362 29.8635C13.2701 30.1715 12.6951 30.1561 22.9578 30.1561C32.2244 30.1561 32.3425 30.1561 32.6711 30.0534C33.3642 29.8378 33.9802 29.2628 34.2523 28.58C34.3602 28.3079 34.3704 28.2001 34.3756 27.3992C34.3756 26.5881 34.3653 26.5059 34.2677 26.3776C34.0419 26.0695 33.9238 26.0233 33.318 26.0079L32.7584 25.9874V21.3258C32.7584 16.7926 32.7532 16.654 32.6557 16.3305C32.4401 15.6375 31.8702 15.0214 31.1823 14.7442C30.8896 14.6261 30.8588 14.6261 29.0004 14.6261C27.1727 14.6261 27.1162 14.6312 26.9725 14.7339C26.6952 14.9392 26.5874 15.16 26.608 15.4783C26.6336 15.8017 26.7722 16.043 27.0238 16.1816C27.1676 16.2587 27.4037 16.2741 28.8823 16.2946C30.7613 16.3254 30.751 16.3203 30.9615 16.6694C31.0591 16.8285 31.0642 16.962 31.0642 21.4131V25.9977H30.8075C30.6689 25.9977 30.5508 25.9874 30.5508 25.972C30.5508 25.8385 29.8577 22.9481 29.7602 22.6606C29.2057 21.0794 27.8401 19.7446 26.2435 19.2261C25.4118 18.954 25.2269 18.9386 22.9526 18.9386C21.1096 18.9386 20.7605 18.954 20.3703 19.031C18.3937 19.4314 16.8433 20.7406 16.1399 22.6093C16.0681 22.7941 15.8576 23.6258 15.6676 24.4575L15.3185 25.972L15.0567 25.9874L14.7897 26.0028L14.8 21.408C14.8154 16.8388 14.8154 16.8131 14.9232 16.6694C14.9797 16.5924 15.108 16.4743 15.2004 16.4075C15.3647 16.2946 15.3955 16.2946 16.9408 16.2946C17.8136 16.2946 18.5939 16.2741 18.6915 16.2433C19.0817 16.1354 19.3692 15.6272 19.2614 15.2421C19.1946 14.9906 19.0303 14.7801 18.825 14.6826C18.6761 14.6107 18.4143 14.6004 16.9357 14.6055C15.6112 14.6055 15.1645 14.6261 14.9489 14.6826ZM21.2892 20.6943C21.2738 20.7457 21.089 21.485 20.8734 22.3372C20.4576 24.0211 20.4165 24.324 20.5962 24.5807C20.6578 24.668 21.1147 25.0171 21.6332 25.3559L22.5573 25.972L19.8209 25.9874C18.3167 25.9925 17.0794 25.9925 17.0692 25.9874C17.064 25.9771 17.1924 25.3713 17.3618 24.6423C17.6134 23.518 17.7006 23.2356 17.8906 22.8455C18.5221 21.5568 19.7285 20.756 21.2482 20.6122C21.2892 20.6071 21.3046 20.643 21.2892 20.6943ZM25.345 20.7406C26.6285 21.0075 27.835 22.1164 28.2097 23.3794C28.297 23.6669 28.8053 25.8693 28.8053 25.9515C28.8053 25.9771 27.6039 25.9977 26.0484 25.9977H23.2863L24.2412 25.3611C24.7649 25.012 25.2321 24.6629 25.2834 24.5807C25.4734 24.2983 25.4477 24.1135 25.0113 22.368C24.7803 21.4542 24.5955 20.6892 24.5955 20.6635C24.5955 20.6071 24.8111 20.6276 25.345 20.7406ZM23.2863 22.4553L23.6098 23.7439L23.2709 23.9698L22.9372 24.1957L22.6241 23.9852C22.4495 23.8671 22.3006 23.7696 22.2904 23.7593C22.2801 23.749 22.4187 23.1535 22.5984 22.4347C22.7781 21.716 22.9321 21.1359 22.9424 21.1461C22.9526 21.1564 23.1066 21.7468 23.2863 22.4553ZM22.0799 28.1026V28.5184L17.9111 28.503L13.7373 28.4876L13.5473 28.3695C13.3779 28.2617 13.1469 27.9126 13.1469 27.7535C13.1469 27.7073 14.2045 27.6919 17.6134 27.6919H22.0799V28.1026ZM32.707 27.8151C32.707 27.9845 32.5068 28.2566 32.2963 28.3798C32.1218 28.4876 32.0499 28.4876 27.9479 28.503L23.7741 28.5184V28.1026V27.6919H28.2405H32.707V27.8151Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_887_23357"
                          x1="0"
                          y1="22"
                          x2="44"
                          y2="22"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#415385" />
                          <stop offset="1" stop-color="#4E77C8" />
                        </linearGradient>
                        <clipPath id="clip0_887_23357">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(10 10)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div className="councoa">
                      <p>
                        <strong>{data?.length}</strong>
                      </p>
                      <p>Total Coach(s)</p>
                    </div>
                  </div>
                  <div className="rightboxcoa d-flex justify-content-around gap-3">
                    <div className="inenrbox">
                      <div className="yrcoa">Your Coach</div>
                      <div className="yrcoabl">No Coach Yet</div>
                    </div>
                    <div className="inenrbox">
                      <div className="yrcoa">Your Coach</div>
                      <div className="yrcoabl">No Coach Yet</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="row mt-5">
              <div className="col-12">
                <h3 className="mentor-title mb-0">{t("suggestedCoach")}(s)</h3>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-12">
                <div className="contsection">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                  >
                    <Tab eventKey={"YourCoaches"} title={t("yourCoaches")}>
                      <div className="inner-content-caoch pt-4">
                        <div className="s-earch-and-filters d-flex gap-3 justify-content-between mb-3">
                          <div className="search-filter position-relative">
                            <input
                              type="search"
                              placeholder={t("Search")}
                              id="inputPassword2"
                              className="form-control"
                              value={searchText}
                              onChange={(e) => {
                                if (_.isEmpty(e.target.value)) {
                                  setSearchText("");
                                } else {
                                  setSearchText(e.target.value);
                                }
                              }}
                            />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              onClick={handleSearchClick}
                              className="cursor-pointer"
                            >
                              <path
                                d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                          <div className="filter-section">
                            <div className="filter-option-listing d-flex justify-content-end gap-3">
                              <Dropdown className="filter-btn">
                                <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                                >
                                  {t("skills")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="drop-down-menu">
                                  {
                                    skillsList.map((skill, index) => (
                                      <Dropdown.Item
                                        key={index}
                                        className="dropdown-menu-item"
                                        onClick={() => {
                                          // setSelectedCity(skill);
                                          // setActiveTab("currentMonth");
                                        }}
                                      >
                                        {skill.label}
                                      </Dropdown.Item>
                                    ))
                                  }
                                </Dropdown.Menu>
                              </Dropdown>

                              <Dropdown className="filter-btn">
                                <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                                >
                                  {t("location")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </Dropdown.Toggle>
                              <Dropdown.Menu className="drop-down-menu">
                                  {
                                    citiesData.map((city) => (
                                      <Dropdown.Item
                                        key={city.id}
                                        onClick={() => {
                                          // setActiveTab("currentMonth");
                                          // setCity(city.id);
                                        }}
                                      >
                                        {city.city}
                                      </Dropdown.Item>
                                    ))
                                  }
                                </Dropdown.Menu>
                              </Dropdown>
                              <Dropdown className="filter-btn">
                                <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                                >
                                  {t("allFilters")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <path
                                      d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="drop-down-menu">
                                  <Dropdown.Item className="dropdown-menu-item active">
                                    1
                                  </Dropdown.Item>
                                  <Dropdown.Item className="dropdown-menu-item">
                                    2
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <div className="councoa d-flex justify-content-start mb-3">
                          {!_.isEmpty(data) && (
                            <p>
                              {t("We found")} {data?.length} coach
                              {data?.length > 1 ? "es" : ""} {t("for you")}
                            </p>
                          )}
                        </div>
                        <div className="row coach-list g-xxl-5 g-4">
                          {!_.isEmpty(data) ? (
                            data?.map((item) => {
                              console.log("check000", item);
                              return (
                                <div className="col-md-6 col-lg-4 col-md-6">
                                  <div className="coach-box">
                                    <div className="above-info">
                                      <div className="img-box-caoch">
                                        <img
                                          src={item?.partner?.thumbnail}
                                          className="img-fluid"
                                        />
                                        <div className="overlay-box-ino d-flex justify-content-between">
                                          <div className="infobox">
                                            {item?.partner?.designation}
                                          </div>
                                          <div className="infobox">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="14"
                                              height="15"
                                              viewBox="0 0 14 15"
                                              fill="none"
                                            >
                                              <g clip-path="url(#clip0_935_21063)">
                                                <path
                                                  d="M2.04761 10.502V14.6625H11.8704V10.502H2.04761Z"
                                                  fill="#4D5E80"
                                                />
                                                <path
                                                  d="M6.95898 10.502H11.8704V14.6625H6.95898V10.502Z"
                                                  fill="#3D4566"
                                                />
                                                <path
                                                  d="M6.5498 10.979H7.36838V12.2069H6.5498V10.979Z"
                                                  fill="#FFDF40"
                                                />
                                                <path
                                                  d="M6.95898 10.979H7.36827V12.2069H6.95898V10.979Z"
                                                  fill="#FFBE40"
                                                />
                                                <path
                                                  d="M9.00545 7.70463H8.18688V6.74502C7.91274 6.63658 7.42902 6.47677 6.95902 6.47677C6.48914 6.47677 6.0055 6.6365 5.73117 6.74505V7.70463H4.9126V6.22381L5.13885 6.11068C5.1758 6.09221 6.05423 5.6582 6.95902 5.6582C7.86381 5.6582 8.74225 6.09221 8.77919 6.11068L9.00545 6.22381V7.70463Z"
                                                  fill="#4D5E80"
                                                />
                                                <path
                                                  d="M8.18684 6.74502V7.70463H9.00541V6.22381L8.77916 6.11068C8.74221 6.09221 7.86378 5.6582 6.95898 5.6582V6.47677C7.42898 6.47677 7.9127 6.63658 8.18684 6.74502Z"
                                                  fill="#3D4566"
                                                />
                                                <path
                                                  d="M11.8704 7.29541V10.502L6.95903 11.3951L2.04761 10.502V7.29541H11.8704Z"
                                                  fill="#3D4566"
                                                />
                                                <path
                                                  d="M11.8704 7.29541H6.95898V11.3951L11.8704 10.502V7.29541Z"
                                                  fill="#2E2E4D"
                                                />
                                                <path
                                                  d="M3.57527 6.55573L2.20965 6.12819L0.844027 6.55573L0.828638 5.12484L0 3.95816L1.35612 3.50135L2.20965 2.35278L3.06317 3.50135L4.41929 3.95816L3.59068 5.12484L3.57527 6.55573Z"
                                                  fill="#FFDF40"
                                                />
                                                <path
                                                  d="M5.59351 4.91852L5.57812 3.48764L4.74951 2.32096L6.10564 1.86414L6.95916 0.715576L7.81265 1.86414L9.16878 2.32096L8.34017 3.48764L8.32481 4.91855L6.95916 4.49101L5.59351 4.91852Z"
                                                  fill="#FFDF40"
                                                />
                                                <path
                                                  d="M13.1561 6.55576L11.7904 6.12822L10.4248 6.55576L10.4094 5.12484L9.58081 3.95816L10.9369 3.50135L11.7904 2.35278L12.6439 3.50135L14 3.95816L13.1714 5.12484L13.1561 6.55576Z"
                                                  fill="#FFDF40"
                                                />
                                                <path
                                                  d="M8.32463 4.91852L8.33999 3.48761L9.1686 2.32096L7.81248 1.86414L6.95898 0.715576V4.49098L8.32463 4.91852Z"
                                                  fill="#FFBE40"
                                                />
                                                <path
                                                  d="M13.1559 6.55573L13.1713 5.12484L13.9999 3.95816L12.6438 3.50135L11.7903 2.35278V6.12819L13.1559 6.55573Z"
                                                  fill="#FFBE40"
                                                />
                                                <path
                                                  d="M3.57536 6.55573L3.59075 5.12484L4.41936 3.95816L3.06324 3.50135L2.20972 2.35278V6.12819L3.57536 6.55573Z"
                                                  fill="#FFBE40"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_935_21063">
                                                  <rect
                                                    width="14"
                                                    height="14"
                                                    fill="white"
                                                    transform="translate(0 0.688965)"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>{" "}
                                            Exp {item?.partner?.experience}yrs
                                          </div>
                                        </div>
                                      </div>
                                      <div className="caoch-info">
                                        <h4 className="coach-tiele">
                                          {item?.partner?.display_name}
                                        </h4>
                                        <div className="coach-desx">
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                item?.partner
                                                  ?.provider_description,
                                            }}
                                          ></p>


                                          <span className="readmore" onClick={() => navigate('/profile/detail', { state: { service_code: service_code } })}>

                                            Read more...
                                          </span>
                                        </div>
                                        <div className="key-skills-coach">
                                          <p>
                                            <strong>{t("keySkills")}</strong>
                                          </p>
                                          <p>
                                            {item?.partner?.skill.map(
                                              (name, index) =>
                                                item?.partner?.skill.length ===
                                                  1
                                                  ? `${name}`
                                                  : item?.partner?.skill
                                                    .length ===
                                                    index + 1
                                                    ? `${name}`
                                                    : `${name}, `
                                            )}
                                          </p>
                                        </div>
                                        {(item?.partner?.linkdin ||
                                          item?.partner?.twitter) && (
                                            <div className="socliwra">
                                              <p>
                                                <strong>
                                                  {t("portfolio")}/{t("profileLink")}
                                                </strong>
                                              </p>
                                              <div className="socililink-caoc">
                                                {item?.partner?.linkdin && (
                                                  <div className="socl-icon">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="24"
                                                      height="25"
                                                      viewBox="0 0 24 25"
                                                      fill="none"
                                                    >
                                                      <g clip-path="url(#clip0_935_21044)">
                                                        <path
                                                          d="M21.829 0.688965H2.17099C0.972 0.688965 0 1.66096 0 2.85996V22.5179C0 23.717 0.972 24.689 2.17099 24.689H21.8289C23.028 24.689 24 23.717 24 22.5179V2.85996C24 1.66096 23.028 0.688965 21.829 0.688965ZM7.42662 21.4121C7.42662 21.7611 7.14377 22.0439 6.79483 22.0439H4.10544C3.7565 22.0439 3.47365 21.7611 3.47365 21.4121V10.1384C3.47365 9.78942 3.7565 9.50658 4.10544 9.50658H6.79483C7.14377 9.50658 7.42662 9.78942 7.42662 10.1384V21.4121ZM5.45014 8.44385C4.0391 8.44385 2.8952 7.29996 2.8952 5.88892C2.8952 4.47789 4.0391 3.33399 5.45014 3.33399C6.86117 3.33399 8.00507 4.47789 8.00507 5.88892C8.00507 7.29996 6.86124 8.44385 5.45014 8.44385ZM21.4813 21.463C21.4813 21.7838 21.2212 22.0439 20.9004 22.0439H18.0145C17.6937 22.0439 17.4335 21.7838 17.4335 21.463V16.175C17.4335 15.3861 17.6649 12.7182 15.372 12.7182C13.5934 12.7182 13.2327 14.5443 13.1602 15.3638V21.463C13.1602 21.7838 12.9002 22.0439 12.5793 22.0439H9.78817C9.46737 22.0439 9.20727 21.7838 9.20727 21.463V10.0875C9.20727 9.76668 9.46737 9.50658 9.78817 9.50658H12.5793C12.9001 9.50658 13.1602 9.76668 13.1602 10.0875V11.071C13.8197 10.0813 14.7998 9.3174 16.8866 9.3174C21.5077 9.3174 21.4813 13.6346 21.4813 16.0067V21.463Z"
                                                          fill="#0077B7"
                                                        />
                                                      </g>
                                                      <defs>
                                                        <clipPath id="clip0_935_21044">
                                                          <rect
                                                            width="24"
                                                            height="24"
                                                            fill="white"
                                                            transform="translate(0 0.688965)"
                                                          />
                                                        </clipPath>
                                                      </defs>
                                                    </svg>
                                                  </div>
                                                )}
                                                {item?.partner?.twitter && (
                                                  <div className="socl-icon">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="24"
                                                      height="25"
                                                      viewBox="0 0 24 25"
                                                      fill="none"
                                                    >
                                                      <g clip-path="url(#clip0_935_21046)">
                                                        <path
                                                          d="M12.8025 12.2793L18.2033 20.0045H15.9868L11.5796 13.7007V13.7003L10.9325 12.7749L5.78418 5.41064H8.00071L12.1554 11.3539L12.8025 12.2793Z"
                                                          fill="black"
                                                        />
                                                        <path
                                                          d="M21.4067 0.688965H2.59325C1.16108 0.688965 0 1.85004 0 3.28222V22.0957C0 23.5279 1.16108 24.689 2.59325 24.689H21.4067C22.8389 24.689 24 23.5279 24 22.0957V3.28222C24 1.85004 22.8389 0.688965 21.4067 0.688965ZM15.308 21.0414L10.8481 14.5507L5.26435 21.0414H3.82122L10.2073 13.6185L3.82122 4.32417H8.69203L12.9152 10.4705L18.2026 4.32417H19.6458L13.5562 11.4029H13.5558L20.1788 21.0414H15.308Z"
                                                          fill="black"
                                                        />
                                                      </g>
                                                      <defs>
                                                        <clipPath id="clip0_935_21046">
                                                          <rect
                                                            width="24"
                                                            height="24"
                                                            fill="white"
                                                            transform="translate(0 0.688965)"
                                                          />
                                                        </clipPath>
                                                      </defs>
                                                    </svg>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                    <div className="caouch-bntfp">
                                      <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
                                        <div className="price-sec-xl">
                                          <span className="signup-btn offer-price-com enroled">
                                            <span>
                                              {ProductCardPriceInfo(
                                                priceInfo.showText,
                                                priceInfo.textColor
                                              )}
                                            </span>
                                          </span>
                                        </div>
                                        <button
                                          type="button"
                                          className="startcourse-btn"
                                          // onClick={item?.btnAction}
                                          onClick={() => {
                                            if (item?.priceInfo?.isPurchased) {
                                              setActiveTab("thisWeek");
                                              setSelectedCoachId(
                                                item?.partner?.user_id
                                              );
                                              setActiveSlot(null);
                                              setSessionModel(true);
                                            } else {
                                              proceedToPurchase(
                                                item?.data,
                                                item?.priceInfo
                                              );
                                            }
                                          }}
                                        >
                                          {item?.priceInfo?.isPurchased
                                            ? t("RequestForASession")
                                            : t("proceed")}{" "}
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                          >
                                            <path
                                              d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                              stroke="#415385"
                                              stroke-width="1.66667"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></path>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <NotFoundComponent
                              width={200}
                              height={219}
                              showBtn={false}
                              showMsg={true}
                              msgLine={t("No Coach Found!")}
                            />
                          )}
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey={"AI"} title={t("aI")}>
                      {t("tabContentForProfile")}
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CartPopUpComponent
          isOpen={isOpen}
          productData={headerProdData}
          closeAction={() => setIsOpen(false)}
          isSubscription={true}
          setMainPageLoading={setInfoModal}
          isMobile={false}
        />
        <Modal
          //fullscreen={true}
          show={sessionModel}
          size="lg"
          onHide={() => setSessionModel(false)}
          className="custom-modal"
          centered
        >
          <Modal.Header closeButton className="p-4">
            <Modal.Title className="mentor-title mb-0">
              {t("bookYourSessionFromAvailableSlots")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {/* Top-level Tabs */}
            <div className="tab-buttons d-flex justify-content-between gap-3 cal-mob flex-column">
              {/* <div className="tab-buttons d-flex justify-content-around mb-3">
              {["thisWeek", "nextWeek", "currentMonth", "nextMonth"].map(
                (tab) => (
                  <button
                    key={tab}
                    className={`btn btn-light ${
                      activeTab === tab ? "active" : ""
                    }`}
                    onClick={() => handleTopTabClick(tab)}
                  >
                    {tab
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </button>
                )
              )}
            </div> */}
              <div className="events-tabs-pills">
                {["thisWeek", "nextWeek", "currentMonth", "nextMonth"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`event-pill ${activeTab === tab ? "active-tab" : ""
                        }`}
                      onClick={() => handleTopTabClick(tab)}
                    >
                      {tab
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, (str) => str.toUpperCase())}
                    </button>
                  )
                )}
              </div>
              {(activeTab === "currentMonth" || activeTab === "nextMonth") && (
                <div className="events-tabs-pills">
                  {_.isArray(activeMonthWeeks) &&
                    activeMonthWeeks?.map((week, index) => (
                      <button
                        key={index}
                        className={`event-pill ${selectedWeek === index ? "active-tab" : ""
                          }`}
                        onClick={() => handleWeekSelection(index)}
                      >
                        Week {index + 1}
                      </button>
                    ))}
                </div>
              )}
            </div>

            {/* Display Weeks for Current Month or Next Month */}
            {/* {(activeTab === "currentMonth" || activeTab === "nextMonth") && (
      <div className="weeks-list mt-3">
        {activeMonthWeeks.map((_, index) => (
          <button
            key={index}
            className="btn btn-outline-secondary me-2 mb-2"
            onClick={() => handleWeekSelection(index + 1)}
          >
            Week {index + 1}
          </button>
        ))}
      </div>
    )} */}

            {/* Content for Current Month or Next Month */}
            {/* {selectedWeekDays.length > 0 && (
  <div className="week-days">
    {selectedWeekDays.map((day, i) => {
      const daySlots = sessions[moment(day, "ddd, DD MMM").format("YYYY-MM-DD")] || []; // Get slots

      return (
        <div key={i} className="day-slot">
          <div className="date">{day}</div>
          <div className="slots">
            {daySlots.length > 0 ? (
              daySlots.map((slot, index) => (
                <div key={index} className="slot">
                  {slot.startTime} - {slot.endTime}
                </div>
              ))
            ) : (
              <div className="no-slots">No Slots Available</div>
            )}
          </div>
        </div>
      );
    })}
  </div>
)} */}

            <div className="wrapper-calds">
              <div className="containertabs mt-4">
                {isFetching ? (
                  <>
                    <div className="listbox d-flex align-items-start">
                      <div className="dtebx date-header text-center d-flex gap-2 flex-column">
                        {[0, 1, 2, 3, 4].map((slot) => (
                          <>
                            <ShimmerScreen
                              case="rect"
                              height="2rem"
                              width="2rem"
                            />
                          </>
                        ))}
                      </div>
                      <div className="datslot-box">
                        {[0, 1, 2, 3, 4].map((slot) => (
                          <>
                            <ShimmerScreen
                              case="rect"
                              height="2.5rem"
                              width="100%"
                            />
                          </>
                        ))}
                      </div>
                    </div>
                  </>
                ) : !_.isEmpty(slotsData) ? (
                  <>
                    {/* Week Tabs (Rendered Only Once) */}

                    {/* Dates and Slots for Selected Week */}
                    {/* Dates and Slots for Selected Week */}
                    {(activeTab === "currentMonth" ||
                      activeTab === "nextMonth") &&
                      selectedWeek !== null &&
                      activeMonthWeeks[selectedWeek] ? (
                      slotsData
                        .filter((dayData) => {
                          const weekStart = moment(
                            activeMonthWeeks[selectedWeek]?.start,
                            "YYYY-MM-DD"
                          );
                          const weekEnd = moment(
                            activeMonthWeeks[selectedWeek]?.end,
                            "YYYY-MM-DD"
                          );

                          const dayDataDate = moment(
                            dayData.date,
                            "YYYY-MM-DD"
                          );

                          // console.log("DayData Date:", dayDataDate.format("YYYY-MM-DD"));
                          // console.log("Week Start:", weekStart.format("YYYY-MM-DD"), "Week End:", weekEnd.format("YYYY-MM-DD"));

                          // Check if dayDataDate falls within the week
                          return dayDataDate.isBetween(
                            weekStart,
                            weekEnd,
                            "days",
                            "[]"
                          );
                        }).sort((a, b) => new Date(a.date) - new Date(b.date))
                        .map((dayData, index) => {
                          console.log("daydata");
                          return (
                            <div className="listbox d-flex" key={index}>
                              <div className="date-box">
                              <div className="text-frame"><span className="number-2">{moment(dayData.date).format("DD")}</span><span className="month-oct"> {moment(dayData.date).format("MMM")}</span></div>
                              
                              </div>
                              <div className="datslot-box">
                                {!_.isEmpty(dayData.slot) &&
                                  dayData.slot.length > 0
                                  ? dayData.slot.sort((slotA, slotB) => slotA.start_time - slotB.start_time).map((slot, slotIndex) => (
                                     <button
                                     disabled={slot.is_booking}

                                      key={slotIndex}
                                      className={`btn btn-primary time-slot-btn ${activeSlot === `${dayData.date}-${slotIndex}` ? "active-page" : ""
                                        }`}
                                        onClick={() => {
                                          if(slot.is_booking){
                                            return
                                          }
                                          const clickedSlot = `${dayData.date}-${slotIndex}`;
                                          if (activeSlot === clickedSlot) {
                                           
                                            setActiveSlot(null);
                                            setSelectedSession(null);
                                          } else {
                                           
                                            setActiveSlot(clickedSlot);
                                            setSelectedSession({
                                              date: moment(dayData.date).format("YYYY-MM-DD"),
                                              startTime: moment.unix(slot.start_time).tz(userDetailRes?.payload?.payload?.timezoneAbbr),
                                              endTime: moment.unix(slot.end_time).tz(userDetailRes?.payload?.payload?.timezoneAbbr).format("HH:mm"),
                                              id:slot.id
                                            });
                                          }
                                        }}
                                      >
                                        {moment.unix(slot.start_time).tz(userDetailRes?.payload?.payload?.timezoneAbbr)
                                          .format("HH:mm")}{" "}
                                        -{" "}
                                        {moment.unix(slot.end_time).tz(userDetailRes?.payload?.payload?.timezoneAbbr)
                                          .format("HH:mm")}
                                          {/* {"sada"+slot.is_booking} */}
                                      </button>
                                    ))
                                  : "No Slots Available"}
                              </div>
                            </div>
                          );
                        })
                    ) : activeTab === "thisWeek" || activeTab === "nextWeek" ? (
                      (activeTab === "thisWeek" ? thisWeekSlots : nextWeekSlots)
                        .length > 0 ? (
                        (activeTab === "thisWeek"
                          ? thisWeekSlots
                          : nextWeekSlots
                        ) .sort((a, b) => {
                          const dateA = new Date(a.date).getTime();
                          const dateB = new Date(b.date).getTime();
                          return dateA - dateB;
                        }).map((dayData, index) => (
                          <div className="listbox d-flex" key={index}>
                            <div className="dtebx date-header text-center">
                              <strong>
                                {moment(dayData.date).format("DD")}
                              </strong>{" "}
                              <br />
                              {moment(dayData.date).format("MMM")}
                            </div>
                            <div className="datslot-box">
                                {!_.isEmpty(dayData.slot) &&
                                dayData.slot.length > 0 
                                  ?   dayData.slot
                                  .sort((slotA, slotB) => {
                                    const timeA = slotA.start_time;
                                    const timeB = slotB.start_time;
                                    return timeA - timeB;
                                  })
                                  .map((slot, slotIndex) => (
                                    <button
                                      disabled={slot.is_booking}
                                      key={slotIndex}
                                      className={`btn btn-primary time-slot-btn ${
                                        activeSlot === `${dayData.date}-${slotIndex}` ? "active-page" : ""
                                      }`}
                                      onClick={() => {
                                        if (slot.is_booking) {
                                          return;
                                        }
                                        const clickedSlot = `${dayData.date}-${slotIndex}`;
                                        if (activeSlot === clickedSlot) {
                                          setActiveSlot(null);
                                          setSelectedSession(null);
                                        } else {
                                          setActiveSlot(clickedSlot);
                                          setSelectedSession({
                                            date: moment(dayData.date).format("YYYY-MM-DD"),
                                            startTime: moment
                                              .unix(slot.start_time)
                                              .tz(userDetailRes?.payload?.payload?.timezoneAbbr)
                                              .format("HH:mm"),
                                            endTime: moment
                                              .unix(slot.end_time)
                                              .tz(userDetailRes?.payload?.payload?.timezoneAbbr)
                                              .format("HH:mm"),
                                            id: slot.id,
                                          });
                                        }
                                      }}
                                    >
                                      {moment
                                        .unix(slot.start_time)
                                        .tz(userDetailRes?.payload?.payload?.timezoneAbbr)
                                        .format("HH:mm")}{" "}
                                      -{" "}
                                      {moment
                                        .unix(slot.end_time)
                                        .tz(userDetailRes?.payload?.payload?.timezoneAbbr)
                                        .format("HH:mm")}
                                    </button>
                                  ))
                                  : "No Slots Available"}
                              </div>
                          </div>
                        ))
                      ) : (
                        <p className="mt-3 text-center">{t("noSlotsAvailable")}</p>
                      )
                    ) : (
                      <p className="mt-3 text-center">
                        {t("selectAWeekTo")}
                      </p>
                    )}
                    {filteredSlotsLength === 0 &&
                      selectedWeek !== null &&
                      selectedWeek !== undefined && (
                        <p className="mt-3 text-center">{t("noSlotsAvailable")}</p>
                      )}
                  </>
                ) : (
                  <NotFoundComponent
                    width={200}
                    height={219}
                    showBtn={false}
                    showMsg={true}
                    msgLine={t("Nothing here, yet.")}
                  />
                )}
              </div>
            </div>
            {error && (
              <Form.Text className="text-danger d-flex justify-content-center ">{error}</Form.Text>
            )}
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-end gap-3 btn-footer p-4 border-0">
            <Button variant="primary" onClick={() => onCancel()}>
              {t("cancel")}
            </Button>
            <Button
              variant="primary"
              className="active-page"
              onClick={() => {
                if (selectedSession) {
                  BookSession(selectedSession);
                } else {
                  handleError()
                }
              }}
            >
              {t("oK")}
            </Button>


          </Modal.Footer>

        </Modal>
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={true}
          isConfirmwithNo={true}
          confirmId={""}
          confirmAction={() => { }}
          isRightIcon={true}
        />
      </>
    </Page>
  );
}

export default SuggestedCoaches;
